export default __webpack_public_path__ + "static/media/Tyson_svg_logo.02828b88.svg";